import * as turf from '@turf/turf';

export type LngLat = readonly [lng: number, lat: number];

/**
 * Returns true if a polygon ring formed by the given [lng, lat] points
 * self-intersects when closed (implicit closing edge last → first included).
 */
export function polygonHasSelfIntersection(points: readonly LngLat[]): boolean {
  if (points.length < 4) return false;

  const ring = [
    ...points.map((p) => [p[0], p[1]]),
    [points[0][0], points[0][1]],
  ];

  try {
    return turf.kinks(turf.polygon([ring])).features.length > 0;
  } catch {
    return false;
  }
}
